import { render, staticRenderFns } from "./VendorTaggings.vue?vue&type=template&id=52df8c55&scoped=true"
import script from "./VendorTaggings.vue?vue&type=script&lang=js"
export * from "./VendorTaggings.vue?vue&type=script&lang=js"
import style0 from "./VendorTaggings.vue?vue&type=style&index=0&id=52df8c55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52df8c55",
  null
  
)

export default component.exports